
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gbIXe", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $bc908b66a83de23c$export$6503ec6e8aabbaf; }, function (v) { return $bc908b66a83de23c$export$6503ec6e8aabbaf = v; });
var $bc908b66a83de23c$export$6503ec6e8aabbaf;
var $bc908b66a83de23c$export$f7ad0328861e2f03;
"use strict";
var $bc908b66a83de23c$var$mapping = new Map();
function $bc908b66a83de23c$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$bc908b66a83de23c$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $bc908b66a83de23c$var$resolve(id) {
    var resolved = $bc908b66a83de23c$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$bc908b66a83de23c$export$6503ec6e8aabbaf = $bc908b66a83de23c$var$register;
$bc908b66a83de23c$export$f7ad0328861e2f03 = $bc908b66a83de23c$var$resolve;

});

var $44234a44b528eade$exports = {};

(parcelRequire("gbIXe")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"dLEl0\",\"index.fbaeefaf.js\",\"cXwW6\",\"mango_nata.0fa548f3.jpg\",\"5a5km\",\"logo_ArteDulce.97bba655.webp\",\"8nWcd\",\"choclolateBlancoConFresas.21655a5e.webp\"]"));

var $29e8e60179e32c9b$exports = {};
$29e8e60179e32c9b$exports = new URL("mango_nata.0fa548f3.jpg", import.meta.url).toString();


var $83bbcbdfeefa7d22$exports = {};
$83bbcbdfeefa7d22$exports = new URL("logo_ArteDulce.97bba655.webp", import.meta.url).toString();


var $74887544db9e9da8$exports = {};
$74887544db9e9da8$exports = new URL("choclolateBlancoConFresas.21655a5e.webp", import.meta.url).toString();


const $87c00c895f415ae7$var$images = [
    (0, (/*@__PURE__*/$parcel$interopDefault($29e8e60179e32c9b$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($83bbcbdfeefa7d22$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($74887544db9e9da8$exports)))
];
let $87c00c895f415ae7$var$gridCells = document.querySelectorAll(".element img");
function $87c00c895f415ae7$export$a09eca1e842cbb35() {
    const randomCell = Math.floor(Math.random() * $87c00c895f415ae7$var$gridCells.length);
    let randomImage = $87c00c895f415ae7$var$images[Math.floor(Math.random() * $87c00c895f415ae7$var$images.length)];
    while(randomImage == $87c00c895f415ae7$var$gridCells[randomCell].src)randomImage = $87c00c895f415ae7$var$images[Math.floor(Math.random() * $87c00c895f415ae7$var$images.length)];
    // Agrega un efecto de fade-out antes de cambiar la imagen
    $87c00c895f415ae7$var$gridCells[randomCell].style.opacity = "0";
    setTimeout(()=>{
        $87c00c895f415ae7$var$gridCells[randomCell].src = randomImage;
        $87c00c895f415ae7$var$gridCells[randomCell].style.opacity = "";
    }, 500); // Tiempo de transición
}
function $87c00c895f415ae7$var$waitForElement(selector, callback) {
    const interval = setInterval(()=>{
        const element = document.querySelector(selector);
        if (element) {
            clearInterval(interval);
            callback(element);
        }
    }, 100); // Check every 100ms
}
// Usage
$87c00c895f415ae7$var$waitForElement('.element img', (element)=>{
    $87c00c895f415ae7$var$gridCells = document.querySelectorAll(".element img");
    if ($87c00c895f415ae7$var$gridCells.length > 0) {
        $87c00c895f415ae7$export$a09eca1e842cbb35();
        // Alternar imágenes cada 2 segundos
        setInterval($87c00c895f415ae7$export$a09eca1e842cbb35, 2000);
    }
// Perform actions on the element
});


(0, $87c00c895f415ae7$export$a09eca1e842cbb35)();


//# sourceMappingURL=index.fbaeefaf.js.map
